<template>
  <div class="detail">
    <!-- <img
      class="detail_img"
      src="@/assets/homeImgs/white_back.png"
      @click="backToLast"
    /> -->
    <div class="detail_top_one">
      {{ productName }}
    </div>

    <div class="detail_top_two">
      <!-- <div class="time_one">签证地：亚洲-泰国</div> -->

      <div v-if="isShowProvince" class="times_two" @click="provinceShow = true">
        送签地：{{ province }} >
      </div>
    </div>
    <div class="detail_time">
      <!-- 截止收材料时间:{{materialDeadline}} -->
    </div>
    <!--申请标题-->
    <div class="application">
      <div class="application_line"></div>
      <div class="application_text">申请签证人信息</div>
    </div>
    <van-form @submit="onSubmit">
      <!--个人信息-->
      <div class="detail_body">
        <!--出行时间-->
        <van-field
          class="time"
          required
          :rules="[{ required: true }]"
          readonly
          clickable
          name="calendar"
          :value="issueDate"
          label="出行日期"
          placeholder="选择出行日期"
          @click="showCalendar = true"
        />
        <van-calendar v-model="showCalendar" @confirm="onConfirm" />
        <!--客户类型-->
        <van-field
          readonly
          clickable
          name="picker"
          :value="clientType"
          label="客户类型"
          placeholder="选择客户类型"
          @click="customerTypePicker = true"
        />
        <van-popup v-model="customerTypePicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="customerSelect"
            @confirm="onConfirmKh"
            @cancel="customerTypePicker = false"
          />
        </van-popup>
        <!--姓名-->
        <van-cell-group>
          <van-field
            required
            :rules="[{ required: true }]"
            v-model="touristName"
            label="姓名"
            placeholder="请输入姓名"
          />
        </van-cell-group>
        <!--姓-->
        <van-cell-group>
          <van-field
            required
            :rules="[{ required: true }]"
            v-model="surname"
            label="姓（拼音）"
            placeholder="请输入姓（拼音）"
            @keyup.native="btKeyUp"
          />
        </van-cell-group>
        <!--名-->
        <van-cell-group>
          <van-field
            required
            :rules="[{ required: true }]"
            v-model="givenName"
            label="名（拼音）"
            placeholder="请输入名（拼音）"
            @keyup.native="btKeyUp1"
          />
        </van-cell-group>
        <!--手机号-->
        <van-cell-group>
          <van-field
            required
            :rules="[{ required: true }]"
            v-model="updateTouristPhone"
            label="手机号"
            @input="emitChange"
            placeholder="请输入手机号"
          />
        </van-cell-group>
        <!--证件类型-->
        <van-field
          readonly
          clickable
          required
          :rules="[{ required: true }]"
          name="picker"
          :value="certType"
          label="证件类型"
          placeholder="选择证件类型"
          @click="paperworkTypePicker = true"
        />
        <van-popup v-model="paperworkTypePicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="paperworkSelect"
            @confirm="onConfirmZj"
            @cancel="paperworkTypePicker = false"
          />
        </van-popup>
        <!--证件号-->
        <van-cell-group>
          <van-field
            required
            :rules="[{ required: true }]"
            v-model="updateCertNo"
            label="证件号"
            @input="emitChange"
            placeholder="请输入证件号"
          />
        </van-cell-group>
        <!--签证材料-->
        <!-- <div class="update">
                     <div class="update_text" required>
                         签证材料
                     </div>
                     <input class="update_value" v-model="updateType"
                            type="text" placeholder="上传签证材料">
                     <div class="update_add" @click="jumpNextRouter('/visa/material-upload')">
                         <div class="update_add_text">
                             上传
                         </div>
                     </div>
                 </div>-->
      </div>
      <!--联系人标题-->
      <div class="contact">
        <div class="contact_line"></div>
        <div class="contact_text">联系人信息</div>
        <img
          style="width: 15px; height: 15px"
          @click="userAlwaysContact(1000, '0')"
          src="@/assets/home/person-place.png"
          alt=""
        />
      </div>
      <!--联系人信息列表-->
      <div class="contact_info">
        <van-cell-group>
          <van-field
            required
            :rules="[{ required: true }]"
            v-model="contactName"
            label="联系人"
            placeholder="请输入联系人"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            required
            :rules="[{ required: true }]"
            v-model="updateContactPhone"
            label="手机号"
            @input="emitChange"
            placeholder="请输入联系人手机号"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            required
            :rules="[{ required: true }]"
            v-model="contactMail"
            label="电子邮箱"
            placeholder="请输入电子邮箱"
          />
        </van-cell-group>
      </div>
      <!--配送标题-->
      <div class="process">
        <div class="process_line"></div>
        <div class="process_text">配送信息</div>
        <img
          style="width: 15px; height: 15px"
          @click="userAlwaysAddress('order-fill')"
          src="@/assets/home/person-place.png"
          alt=""
        />
      </div>
      <!--配送信息-->
      <div class="return_method">
        <!--配送地址-->
        <van-cell-group>
          <van-field
            required
            :rules="[{ required: true }]"
            v-model="consigneeName"
            label="收件人"
            placeholder="请输入收件人"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            required
            :rules="[{ required: true }]"
            v-model="updateConsigneePhone"
            label="手机号"
            @input="emitChange"
            placeholder="请输入手机号"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            required
            :rules="[{ required: true }]"
            v-model="consigneeEmail"
            label="电子邮箱"
            placeholder="请输入电子邮箱"
          />
        </van-cell-group>
        <!--选择地区-->
        <van-field
          readonly
          clickable
          required
          :rules="[{ required: true }]"
          name="area"
          :value="value"
          label="地区选择"
          placeholder="点击选择省市区"
          @click="showArea = true"
        />
        <van-popup v-model="showArea" position="bottom">
          <van-area
            :area-list="areaList"
            @confirm="onConfirmArea"
            @cancel="showArea = false"
          />
        </van-popup>
        <van-cell-group>
          <van-field
            required
            :rules="[{ required: true }]"
            v-model="consigneeAddressDetail"
            label="配送地址"
            placeholder="请输入配送地址"
          />
        </van-cell-group>
      </div>
      <div class="process" v-if="!activityInfo">
        <div class="process_line"></div>
        <div class="process_text">优惠券</div>
      </div>
      <div class="coupon-box" @click="selectCoupon" v-if="!activityInfo">
        <div class="coupon-content">
          <div class="coupon-label">我的优惠券</div>
          <div class="coupon-price-box">
            <div class="coupon-price">-¥{{ coupon }}</div>
            <img src="@/assets/order/gray_right_icon.png" class="coupon-img" />
          </div>
        </div>
      </div>
      <div v-if="fileList.length > 0" class="process">
        <div class="process_line"></div>
        <div class="process_text">签证材料</div>
      </div>
      <div v-if="fileList.length > 0" class="visa-file-box">
        <!-- <common-title title="签证材料" :hiddenBottomLine="true"></common-title> -->
        <div class="file-box" v-for="(item, index) in fileList" :key="index">
          <div class="file-box-item">
            材料类型： {{ getfileTypeWithFile(item) }}
          </div>
          <div class="file-box-item">材料名称： {{ item.fileName }}</div>
          <div class="file-content-box">
            <div class="file-content-label">材料说明：</div>
            <div class="file-content">{{ item.fileContent }}</div>
          </div>
          <div class="file-modal-box">
            <div class="file-modal-label">材料模版：</div>
            <div class="file-modal-list">
              <div
                class="modal-item"
                v-for="(i, idx) in item.fileList"
                :key="idx"
                @click="seeModelImage(item, idx)"
              >
                {{ idx + 1 }}、{{ i.mouldName }}
              </div>
            </div>
          </div>
          <div class="file-box-item">
            是否必须：{{ getfileRequireWithFile(item) }}
          </div>
        </div>
      </div>
      <!--支付-->
      <div class="defray">
        <div class="total">合计</div>
        <div class="number_text">￥</div>
        <div class="number_value">
          {{ productMarketPrice }}
        </div>
        <!--  <div class="save_money">
          <div class="save_number">
            已省￥20
          </div>
        </div>-->
        <!-- <div class="detail_text">
                     明细
                 </div>
                 <div class="img">

                 </div>-->
        <!-- <div class="to_pay" @click="toPay">
                     <div class="to_pay_text">
                         支付
                     </div>
                 </div>-->
        <van-button class="to_pay" native-type="submit">
          <span class="to_pay_text"> 支付 </span>
        </van-button>
      </div>
    </van-form>
    <!-- 优惠券 -->
    <van-popup
      v-model="showCouponCard"
      closeable
      position="bottom"
      :style="{ height: '440px' }"
    >
      <couponsCard
        :type="4"
        :productList="couponProductList"
        productType="6"
        :key="couponCardKey"
        @goPay="getCoupons"
        @noPay="noUseCoupons"
      ></couponsCard>
    </van-popup>
    <van-popup v-model="provinceShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="provinceShowList"
        @confirm="onConfirmProvince"
        @cancel="provinceShow = false"
      />
    </van-popup>
  </div>
</template>

<script>
import commonTitle from "@/components/common_title.vue";
import { Dialog, ImagePreview, Notify } from "vant";
import { isPhone, isIdCardNumber, isPinYin, isEmail } from "@/utils/validate";
import area from "@/lib/area.js";
import couponsCard from "@/components/coupons-card.vue";
import { getUserMaxCounpon } from "../market/market-util";

export default {
  name: "order-fill",
  components: {
    commonTitle,
    couponsCard,
  },
  data() {
    return {
      materialDeadline: "", //材料截至时间
      issueDate: "", //签发日期
      clientType: "", //客户类型
      customerTypePicker: false,
      customerSelect: [],
      touristName: "", //游客姓名
      surname: "", //姓拼音
      givenName: "", //名拼音
      touristPhone: "", //游客手机号
      certType: "", //证件类型
      paperworkTypePicker: false,
      paperworkSelect: ["身份证", "护照", "军官证", "台湾通行证", "港澳通行证"],
      certNo: "", //证件号
      contactName: "", //联系人姓名
      contactPhone: "", //联系人电话
      contactMail: "", //联系人邮箱
      consigneeName: "", //收件人姓名
      consigneePhone: "", //收件人电话
      consigneeEmail: "", //收件人邮箱
      consigneeAddressDetail: "", //收件人地址
      placeOrderUserId: "",
      placeOrderTenantId: "",
      placeOrderUserName: "",
      showCalendar: false,
      productName: "",
      productMarketPrice: "",
      productId: "",
      orderItemList: [],
      orderTouristList: [],
      orderContactList: [],
      orderDeliveryInfo: {},
      isExtraOrder: false,
      placeOrderType: 0,
      orderAttestorFileList: [],
      visaFileId: 0,
      attestorFileUploadList: [],
      fileName: "",
      filePath: "",
      certTypeNumber: "",
      value: "",
      showArea: false,
      areaList: area, // 数据格式见 Area 组件文档
      consigneeAddressProvince: "",
      consigneeAddressCity: "",
      consigneeAddressTown: "",
      payList: [],
      orderNo: "",
      updateTouristPhone: "",
      updateConsigneePhone: "",
      updateContactPhone: "",
      updateCertNo: "",

      activityInfo: null, // 活动数据
      stuffTypeList: [], // 材料类型列表
      fileIsRequireList: [], //材料是否必须要
      fileList: [], //文件列表
      customerList: [], //客户类型列表
      serviceRegion: "",
      currentIdex: 0,

      coupon: 0, //优惠券价格
      showCouponCard: false, // 显示优惠券
      couponCardKey: 1, //每次显示优惠券都请求
      couponProductList: [], // 优惠券请求参数
      currentPrice: 0, //当前总价（不变的）
      couponPriceData: {}, //选取优惠券之后的价格对象
      noCoupon: false,
      provinceCode: "",
      cityCode: "",
      countryCode: "",
      province: "请选择送签地省份", //省份
      provinceList: [], //省份列表
      provinceShowList: [], //显示省份弹框列表
      provinceShow: false, //是否显示省份弹框列表
      isShowProvince: false, //默认不显示
    };
  },
  mounted() {
    //要传 1分销商 2分销员 3直客 （identityType 3 、4 、5 要对应转成这个3个身份值）
    let userInfo = this.$store.state.userInfo_v2;
    if (userInfo.identity.identityType == "3") {
      this.placeOrderType = "1";
    } else if (userInfo.identity.identityType == "4") {
      this.placeOrderType = "2";
    } else if (userInfo.identity.identityType == "5") {
      this.placeOrderType = "3";
    }
    this.activityInfo = this.$route.query.activityInfo;
    this.productId = this.$route.query.productId;
    this.productName = this.$route.query.productName;
    this.serviceRegion = this.$route.query.serviceRegion;
    this.isShowProvince = !this.$route.query.serviceRegion;
    // this.province = this.$route.query.province;
    if (this.activityInfo && this.activityInfo.mainType !== "bargain") {
      this.productMarketPrice = this.activityInfo.activityPrice;
      this.currentPrice = this.activityInfo.activityPrice;
    } else {
      this.productMarketPrice = this.$route.query.productMarketPrice;
      this.currentPrice = this.$route.query.productMarketPrice;
    }

    this.placeOrderUserName = this.$store.state.userInfo_v2.user.userName;
    this.placeOrderUserId = this.$store.state.userInfo_v2.user.userId;
    this.placeOrderTenantId = this.$store.state.userInfo_v2.user.tenantId;
    // this.roleKey = this.$store.state.userInfo_v2.user.roles[0].roleKey;
    this.getcustomType();
    this.getTypeRequest();

    // 获取最大可用优惠券
    if (!this.activityInfo) {
      this.getMaxCounpon();
    }
    // if (!this.serviceRegion) {
    this.getRegionByProId();
    // }
  },
  activated() {
    if (this.$route.params) {
      if (this.$route.params.user) {
        if (this.currentIdex == 1000) {
          this.contactName = this.$route.params.user.name;
          this.updateContactPhone = this.$route.params.user.mobile;
        }
      }
      if (this.$route.params.addressManager) {
        this.consigneeName = this.$route.params.addressManager.consigneeName;
        this.updateConsigneePhone = this.$route.params.addressManager.mobile;
        this.consigneeAddressDetail = this.$route.params.addressManager.address;
        this.provinceCode = this.$route.params.addressManager.province;
        this.cityCode = this.$route.params.addressManager.city;
        this.countryCode = this.$route.params.addressManager.county;
        this.consigneeAddressProvince =
          area.province_list[this.$route.params.addressManager.province];
        this.consigneeAddressCity =
          area.city_list[this.$route.params.addressManager.city];
        this.consigneeAddressTown =
          area.county_list[this.$route.params.addressManager.county];
        this.value =
          this.consigneeAddressProvince +
          "/" +
          this.consigneeAddressCity +
          "/" +
          this.consigneeAddressTown;
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name == "alwaysContact" || from.name == "addressManage") {
        vm.$store.commit("SET_KEEP_ALIVE", [to.name]);
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == "alwaysContact" || to.name == "addressManage") {
      this.$store.commit("SET_KEEP_ALIVE", [from.name]);
    } else {
      this.$store.commit("SET_KEEP_ALIVE", []);
    }
    next();
  },
  methods: {
    btKeyUp(e) {
      //没有显示‘破折号’和 '.' 需要的可以手动加上
      this.surname = e.target.value.replace(
        /[\u4e00-\u9fa5/\s+/]|[`~!@#$%^&*() \+ =<>?"{}|, \/ ;' \\ [ \] ·~！@#￥%……&*（）—— \+ ={}|《》？：“”【】、；‘’，。、]/g,
        ""
      );
      console.log(this.surname);
    },
    btKeyUp1(e) {
      //没有显示‘破折号’和 '.' 需要的可以手动加上
      this.givenName = e.target.value.replace(
        /[\u4e00-\u9fa5/\s+/]|[`~!@#$%^&*() \+ =<>?"{}|, \/ ;' \\ [ \] ·~！@#￥%……&*（）—— \+ ={}|《》？：“”【】、；‘’，。、]/g,
        ""
      );
      console.log(this.givenName);
    },

    onConfirmProvince(value) {
      for (let index = 0; index < this.provinceList.length; index++) {
        const element = this.provinceList[index];
        if (element.dictLabel == value) {
          this.serviceRegion = element.dictValue;
          break;
        }
      }
      this.province = value;
      this.provinceShow = false;
    },
    getMaxCounpon() {
      // 优惠券商品价格参数
      this.couponProductList = [
        { productId: this.productId, productPrice: this.currentPrice },
      ];
      var param = {
        productInfoList: this.couponProductList,
        productType: "6",
        receiveChannel: "h5",
      };
      getUserMaxCounpon(param, (res) => {
        if (res) {
          this.getCoupons(res);
        }
      });
    },
    // 选择优惠券
    selectCoupon() {
      // 优惠券商品价格参数
      this.couponProductList = [
        { productId: this.productId, productPrice: this.currentPrice },
      ];
      this.showCouponCard = true;
      this.couponCardKey++;
    },
    // 选中优惠券回调
    getCoupons(item) {
      this.noCoupon = false;
      this.showCouponCard = false;
      // 得到了优惠券 重新计算价格
      let user = this.$store.state.userInfo_v2.user;
      var param = {
        totalMoney: this.currentPrice,
        productType: "6",
        couponsId: item.id,
        userId: user.userId,
        userName: user.userName,
        useChannel: "h5",
        apiCouponsProductRequest: [
          {
            productPrice: this.currentPrice,
            productId: this.productId,
            productType: this.productType,
          },
        ],
      };
      this.$API.coupons
        .getPriceByCounpon(param)
        .then((res) => {
          this.couponPriceData = res.data;
          this.productMarketPrice = this.couponPriceData.actualPrice + "";
          this.coupon = this.couponPriceData.discountPrice;
        })
        .catch((err) => {});
    },
    noUseCoupons() {
      //清空优惠券
      this.noCoupon = true;
      this.showCouponCard = false;
      this.couponPriceData = {};
      this.coupon = 0;
      if (this.activityInfo && this.activityInfo.mainType !== "bargain") {
        this.productMarketPrice = this.activityInfo.activityPrice;
        this.currentPrice = this.activityInfo.activityPrice;
      } else {
        this.productMarketPrice = this.$route.query.productMarketPrice;
        this.currentPrice = this.$route.query.productMarketPrice;
      }
    },
    //常用联系人
    userAlwaysContact(index, type) {
      this.currentIdex = index;
      console.log("常用联系人", index);
      this.$router.push({
        path: "/order/alwaysContact",
        query: { isTourist: type },
      });
    },
    //配送地址
    userAlwaysAddress(from) {
      console.log("常用地址", from);
      this.$router.push({
        path: "/person/addressManage",
        query: { from: from },
      });
    },
    getfileTypeWithFile(item) {
      var tempStr = "";
      this.stuffTypeList.forEach((e) => {
        if (e.dictValue == item.fileType) {
          tempStr = e.dictLabel;
        }
      });
      return tempStr;
    },
    getfileRequireWithFile(item) {
      var tempStr = "";
      this.fileIsRequireList.forEach((e) => {
        if (e.dictValue == item.isRequire) {
          tempStr = e.dictLabel;
        }
      });
      return tempStr;
    },
    getTypeRequest() {
      this.$API.z_product.y_stuff_type().then((res) => {
        this.stuffTypeList = res.data;
      });
      this.$API.z_product.y_visa_file_is_require().then((res) => {
        this.fileIsRequireList = res.data;
      });
    },
    getcustomType() {
      this.$API.z_product.y_visa_client_type().then((res) => {
        var tempArr = [];
        res.data.forEach((e) => {
          tempArr.push(e.dictLabel);
        });
        this.getCustomerAvaildType(res.data);
        this.customerList = res.data;
      });
    },
    //获取客户列表可用类型
    getCustomerAvaildType(typeArr) {
      var that = this;
      this.$API.x_person
        .visaviewDetail(this.productId, this.serviceRegion)
        .then((res) => {
          let clientType = res.data.productVisa.clientType;
          var tempArr = [];
          typeArr.forEach((element) => {
            if (clientType.indexOf(element.dictValue) != -1) {
              tempArr.push(element.dictLabel);
            }
          });
          that.customerSelect = tempArr;
        });
    },
    getfileListRequest() {
      var idx = this.customerSelect.indexOf(this.clientType);
      var dictValue = "";
      this.customerList.forEach((element) => {
        if (element.dictLabel == this.clientType) {
          dictValue = element.dictValue;
        }
      });
      this.$API.z_product
        .productVisaFile(this.productId, dictValue)
        .then((res) => {
          this.fileList = res.data;
        });
    },
    getRegionByProId() {
      this.$API.z_product.getRegionByProId(this.productId).then((res) => {
        this.provinceList = res.data;
        this.provinceShowList = res.data.map((e) => {
          return e.dictLabel;
        });
      });
    },
    //返回
    backToLast() {
      this.$router.go(-1);
    },
    //出行日期选择
    onConfirm(date) {
      this.issueDate = `${date.getFullYear()}-${date.getMonth() +
        1}-${date.getDate()}`;
      this.showCalendar = false;
      this.getAfterTime(date);
    },
    //获取10天之后的时间
    getAfterTime(date) {
      date.setDate(date.getDate() + 10);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`;
      }
      this.materialDeadline = `${year}年${month}月${day}日`;
    },
    //选择客户类型
    onConfirmKh(value) {
      this.clientType = value;
      this.customerTypePicker = false;
      this.getfileListRequest();
    },
    //选择证件类型
    onConfirmZj(value) {
      this.certType = value;
      this.paperworkTypePicker = false;
    },
    //选择省市县
    onConfirmArea(values) {
      this.value = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join("/");
      this.consigneeAddressProvince = values[0].name;
      this.provinceCode = values[0].code;
      this.consigneeAddressCity = values[1].name;
      this.cityCode = values[1].code;
      this.consigneeAddressTown = values[2].name;
      this.countryCode = values[2].code;
      this.showArea = false;
    },
    //跳转
    jumpNextRouter(path) {
      if (path && path.length) {
        this.$router.push({ path: path });
      }
    },
    // 触发改变事件
    emitChange() {
      //   this.updateContactPhone = this.contactPhone;
      //   this.updateConsigneePhone = this.consigneePhone;
      //   this.updateTouristPhone = this.touristPhone;
      //   this.updateCertNo = this.certNo;
    },

    //支付
    onSubmit() {
      if (this.province == "请选择送签地省份") {
        return Notify({
          type: "warning",
          message: "请选择送签地省份",
        });
      }
      if (!isPinYin(this.surname)) {
        return Notify({
          type: "warning",
          message: "请填写正确的姓拼音",
        });
      }
      if (!isPinYin(this.givenName)) {
        return Notify({
          type: "warning",
          message: "请填写正确的名拼音",
        });
      }
      if (!isPhone(this.updateTouristPhone)) {
        return Notify({
          type: "warning",
          message: "请填写正确的申请人手机号",
        });
      }
      if (!isPhone(this.updateContactPhone)) {
        return Notify({
          type: "warning",
          message: "请填写正确的联系人手机号",
        });
      }
      if (!isPhone(this.updateConsigneePhone)) {
        return Notify({
          type: "warning",
          message: "请填写正确的收件人手机号",
        });
      }
      if (this.certType == "身份证") {
        if (!isIdCardNumber(this.updateCertNo)) {
          return Notify({
            type: "warning",
            message: "请填写正确的申请人身份证号",
          });
        }
      }
      if (!isEmail(this.contactMail)) {
        return Notify({
          type: "warning",
          message: "请填写正确的联系人邮箱",
        });
      }

      if (!isEmail(this.consigneeEmail)) {
        return Notify({
          type: "warning",
          message: "请填写正确的收件人邮箱",
        });
      }

      Dialog.confirm({
        title: "",
        message: "请确认是否支付",
        confirmButtonText: "支付",
        confirmButtonColor: "#3377FF",
      }).then(() => {
        try {
          let orderItem = {
            orderQuantity: 1, //下单数量
            startDate: this.issueDate, //开始使用日期
            orderMemo: "", //备注
            productId: this.productId, //产品ID
            productType: "6", //产品类型
            originType: 2,
            placeOrderType: this.placeOrderType, //下单人类型
            shouldPayMoney: this.productMarketPrice, //应付总价
            totalMoney: this.productMarketPrice, //下单总价
            discountMoney: 0, //优惠金额
            extraPrice: 0, //额外附件费用
          };
          this.orderItemList.push(orderItem); //下单列表

          let orderContact = {
            name: this.contactName,
            phone: this.updateContactPhone,
            certNo: "",
            email: this.contactMail,
          };
          this.orderContactList.push(orderContact); //联系人

          if (this.certType == "身份证") {
            this.certTypeNumber = "1";
          } else if (this.certType == "护照") {
            this.certTypeNumber = "2";
          } else if (this.certType == "军官证") {
            this.certTypeNumber = "3";
          } else if (this.certType == "台胞证") {
            this.certTypeNumber = "4";
          } else if (this.certType == "回乡证") {
            this.certTypeNumber = "5";
          } else if (this.certType == "户口本") {
            this.certTypeNumber = "6";
          } else if (this.certType == "国外人永久居留证") {
            this.certTypeNumber = "7";
          } else if (this.certType == "港澳台居民居住证") {
            this.certTypeNumber = "8";
          } else if (this.certType == "台湾通行证") {
            this.certTypeNumber = "9";
          } else if (this.certType == "港澳通行证") {
            this.certTypeNumber = "10";
          } else if (this.certType == "其他") {
            this.certTypeNumber = "99";
          }

          let fileUploadList = {
            fileName: "",
            filePath: "",
          };
          this.attestorFileUploadList.push(fileUploadList);

          let orderAttestorFileList = {
            visaFileId: this.visaFileId,
            attestorFileUploadList: this.attestorFileUploadList,
          };
          this.orderAttestorFileList.push(orderAttestorFileList);
          let orderTourist = {
            name: this.touristName, //姓名
            phone: this.updateTouristPhone, //电话
            certType: this.certTypeNumber, //证件类型
            certNo: this.updateCertNo, //证件号
            email: "", //邮箱
            surname: this.surname, //姓拼音
            givenName: this.givenName, //名拼音
            attestorFileStatus: "0",
            clientType: this.clientType, //客户类型
            orderAttestorFileList: this.orderAttestorFileList,
          };
          this.orderTouristList.push(orderTourist); //申请人

          this.orderDeliveryInfo.consigneeName = this.consigneeName; //收件人姓名
          this.orderDeliveryInfo.consigneePhone = this.updateConsigneePhone; //收件人手机号
          this.orderDeliveryInfo.consigneeEmail = this.consigneeEmail; //收件人邮箱
          this.orderDeliveryInfo.consigneeAddressProvince = this.provinceCode; //this.consigneeAddressProvince; //省
          this.orderDeliveryInfo.consigneeAddressCity = this.city; //this.consigneeAddressCity; //市
          this.orderDeliveryInfo.consigneeAddressTown = this.countryCode; //this.consigneeAddressTown; //县
          this.orderDeliveryInfo.consigneeAddressDetail = this.consigneeAddressDetail; //详细地址
          var params = {
            isExtraOrder: false,
            orderItemList: this.orderItemList, //下单列表
            orderTouristList: this.orderTouristList, //申请人
            orderContactList: this.orderContactList, //联系人
            orderDeliveryInfo: this.orderDeliveryInfo, //配送信息
            couponId: this.couponPriceData.couponsId || "",
            additionalItemMap: {
              serviceRegion: this.serviceRegion,
            },
            /*  placeOrderUserId: this.placeOrderUserId,//下单人编码
                          placeOrderTenantId: this.placeOrderTenantId,//下单租户ID
                          placeOrderUserName: this.placeOrderUserName,//下单人姓名*/
          };
          if (this.activityInfo) {
            params.activityInfo = {
              mainId: this.activityInfo.mainId,
              mainType: this.activityInfo.mainType,
            };
            if (this.activityInfo.id) {
              params.activityInfo.id = this.activityInfo.id;
            }
          }
          this.loading = true;
          this.$API.x_person.createOrder(params).then((res) => {
            this.$toast("下单成功");
            this.loading = false;

            const activeMainType = this.activityInfo?.mainType || "";
            if (activeMainType === "bargain") {
              // 砍价
              const data = {
                activityId: res.data.activityId,
                mainId: this.activityInfo.mainId,
                productId: this.productId,
                showShare: true,
              };
              this.$router.push({
                name: "bargain-detail",
                query: data,
              });
            } else {
              this.orderNo = res.data.orderNo;
              let payParams = {
                orderNo: this.orderNo,
                shouldPay: this.productMarketPrice,
                productType: "6",
                goNumber: -4,
              };
              localStorage.setItem("testData", JSON.stringify(payParams));
              this.$router.push({
                path: "/pay/pay",
                query: payParams,
              });
            }
          });
        } catch (e) {
          this.$toast("下单失败" + e);
          this.loading = false;
        }
      });
    },

    seeModelImage(item, index) {
      const image = item.fileList.map((res) => {
        return res.filePath;
      });
      ImagePreview({
        images: image,
        startPosition: index,
        closeable: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.detail {
  background: linear-gradient(181deg, $theme-color 0%, #f4f6f9 25%);
  height: 100%;
  padding-bottom: vw(1300);

  .detail_img {
    width: vw(28);
    height: vw(28);
    margin-left: vw(38);
    margin-top: vw(30);
  }

  .detail_top_one {
    margin-left: vw(32);
    padding-top: vw(50);
    width: vw(686);
    font-size: vw(42);
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
    opacity: 1;
  }

  .detail_top_two {
    display: flex;
    flex-direction: row;
    text-align: center;

    .time_one {
      margin-left: vw(32);
      margin-top: vw(16);
      font-size: vw(24);
      font-family: Source Han Sans CN;
      color: #ffffff;
      opacity: 1;
    }

    .line_one {
      height: vw(28);
      background-color: #ffffff;
      margin-left: vw(16);
      margin-top: vw(20);
    }

    .times_two {
      margin-left: vw(40);
      margin-top: vw(16);
      font-size: vw(24);
      font-family: Source Han Sans CN;
      color: #ffffff;
      opacity: 1;
    }

    .line_two {
      margin-left: vw(16);
      margin-top: vw(20);
      height: vw(28);
      background-color: #ffffff;
    }
  }

  .detail_time {
    margin-left: vw(32);
    margin-top: vw(16);
    font-size: vw(24);
    font-family: Source Han Sans CN;
    color: #ff0000;
    opacity: 1;
  }

  .application {
    display: flex;
    align-content: center;
    flex-direction: row;

    .application_line {
      margin-top: vw(40);
      margin-left: vw(32);
      width: vw(8);
      height: vw(30);
      background: $theme-color;
      opacity: 1;
      border-radius: vw(12);
    }

    .application_text {
      margin-top: vw(35);
      margin-left: vw(24);
      font-size: vw(30);
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
      opacity: 1;
    }
  }

  .detail_body {
    margin-left: vw(32);
    margin-top: vw(24);
    margin-right: vw(32);
    padding-top: vw(20);
    padding-bottom: vw(20);
    background: #fff;
    border-radius: vw(12);

    .time {
      // border-radius: vw(12) vw(12) vw(0) vw(0);
    }

    .update {
      width: vw(686);
      height: vw(100);
      display: flex;
      align-content: center;
      flex-direction: row;
      background-color: #ffffff;
      justify-content: space-between;
      // border-radius: vw(0) vw(0) vw(12) vw(12);

      .update_text {
        width: vw(130);
        margin-top: vw(32);
        margin-left: vw(32);
        color: #333333;
        font-size: vw(26);
        font-family: Source Han Sans CN;
      }

      .update_value {
        width: vw(300);
        border: none;
        margin-left: vw(50);
        color: #333333;
        font-size: vw(26);
        font-family: Source Han Sans CN;
      }

      .update_add {
        margin-top: vw(15);
        margin-right: vw(32);
        width: vw(112);
        height: vw(68);
        background: #f2f7ff;
        border-radius: vw(8);
        line-height: vw(68);

        .update_add_text {
          margin-left: vw(30);
          font-size: vw(26);
          font-family: Source Han Sans CN;
          color: $theme-color;
          opacity: 1;
        }
      }
    }
  }

  .contact {
    margin-top: vw(40);
    display: flex;
    align-items: center;
    flex-direction: row;

    .contact_line {
      margin-left: vw(32);
      width: vw(8);
      height: vw(30);
      background: $theme-color;
      // opacity: 1;
      // border-radius: vw(12);
    }

    .contact_text {
      // margin-top: vw(35);
      margin-right: vw(15);
      margin-left: vw(24);
      font-size: vw(30);
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
    }
  }

  .contact_info {
    margin-top: vw(32);
    margin-left: vw(32);
    margin-right: vw(32);
    padding-top: vw(15);
    padding-bottom: vw(20);
    background: #fff;
    border-radius: vw(12);

    .contact_one {
      width: vw(686);
      height: vw(102);
      background: #ffffff;
      // border-radius: vw(12) vw(12) vw(0) vw(0);
      display: flex;
      flex-direction: row;
      align-content: center;

      .contact_person_info {
        width: vw(130);
        margin-top: vw(32);
        margin-left: vw(32);
        color: #333333;
        font-size: vw(26);
        font-family: Source Han Sans CN;
        opacity: 1;
      }

      .contact_value {
        border: none;
        margin-left: vw(60);
        color: #333333;
        font-size: vw(26);
        font-family: Source Han Sans CN;
        opacity: 1;
      }
    }

    .contact_two {
      margin-top: vw(2);
      width: vw(686);
      height: vw(102);
      background: #ffffff;
      display: flex;
      flex-direction: row;
      align-content: center;

      .phone_info {
        width: vw(130);
        margin-top: vw(32);
        margin-left: vw(32);
        color: #333333;
        font-size: vw(26);
        font-family: Source Han Sans CN;
        opacity: 1;
      }

      .phone_value {
        border: none;
        margin-left: vw(60);
        color: #333333;
        font-size: vw(26);
        font-family: Source Han Sans CN;
        opacity: 1;
      }
    }

    .contact_three {
      margin-top: vw(2);
      width: vw(686);
      height: vw(102);
      background: #ffffff;
      display: flex;
      flex-direction: row;
      align-content: center;
      // border-radius: vw(0) vw(0) vw(12) vw(12);

      .mail_info {
        width: vw(130);
        margin-top: vw(32);
        margin-left: vw(32);
        color: #333333;
        font-size: vw(26);
        font-family: Source Han Sans CN;
        opacity: 1;
      }

      .mail_value {
        border: none;
        margin-left: vw(60);
        color: #333333;
        font-size: vw(26);
        font-family: Source Han Sans CN;
        opacity: 1;
      }
    }
  }

  .process {
    margin-top: vw(40);
    display: flex;
    align-items: center;
    flex-direction: row;

    .process_line {
      margin-left: vw(32);
      width: vw(8);
      height: vw(30);
      background: $theme-color;
      opacity: 1;
      border-radius: vw(12);
    }

    .process_text {
      margin-left: vw(24);
      margin-right: vw(15);
      font-size: vw(30);
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
      opacity: 1;
    }
  }

  .coupon-box {
    background-color: #f4f6f9;
    padding: vw(10) vw(32);
    // padding-bottom: vw(30);
    .coupon-content {
      background-color: #ffffff;
      border-radius: vw(12);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      color: #333333;
      font-size: vw(28);
      padding-top: vw(25);
      padding-bottom: vw(25);
      .coupon-label {
        margin-left: vw(15);
      }
      .coupon-price-box {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-right: vw(15);
        .coupon-price {
          color: #ff3333;
          margin-right: vw(10);
        }
        .coupon-img {
          width: vw(20);
          height: vw(25);
        }
      }
    }
  }

  .return_method {
    margin-left: vw(32);
    margin-top: vw(30);
    margin-right: vw(32);
    padding-bottom: vw(20);
    padding-top: vw(15);
    background: #ffffff;
    border-radius: vw(12);
  }
  .visa-file-box {
    padding: vw(20) vw(30);
    padding-bottom: vw(130);
    margin-bottom: vw(110);
    background-color: #f4f6f9;
    display: flex;
    flex-direction: column;
    font-size: vw(28);
    color: #666666;
    .file-box {
      margin-bottom: vw(20);
      padding: vw(20);
      background-color: #fff;
      border-radius: vw(10);
      .file-box-item {
        margin-bottom: vw(20);
      }
      .file-content-box {
        margin-bottom: vw(20);
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        .file-content-label {
          width: vw(140);
        }
        .file-content {
          margin-left: vw(10);
          flex: 1;
        }
      }
      .file-modal-box {
        margin-bottom: vw(20);
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        .file-modal-label {
          width: vw(140);
        }
        .file-modal-list {
          margin-left: vw(10);
          flex: 1;
          .modal-item {
            color: $theme-color;
            font-size: vw(28);
            white-space: normal;
            word-break: break-all;
            word-break: break-word;
          }
        }
      }
    }
  }

  .defray {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: vw(110);
    padding-bottom: vw(30);
    background: #ffffff;
    display: flex;
    flex-direction: row;
    align-content: center;
    /*  justify-content: space-between;*/

    .total {
      height: vw(36);
      margin-top: vw(45);
      margin-left: vw(30);
      font-size: vw(28);
      color: #333333;
      font-family: Source Han Sans CN;
    }

    .number_text {
      height: vw(36);
      margin-top: vw(45);
      font-size: vw(28);
      color: #ff3333;
      font-family: Source Han Sans CN;
    }

    .number_value {
      height: vw(36);
      margin-top: vw(37);
      font-size: vw(36);
      color: #ff3333;
      font-family: Source Han Sans CN;
    }

    .save_money {
      margin-left: vw(20);
      margin-top: vw(40);
      width: vw(104);
      height: vw(36);
      border: vw(1) solid #ff593a;
      opacity: 1;
      border-radius: vw(4);

      .save_number {
        margin-top: vw(3);
        text-align: center;
        font-size: vw(22);
        font-family: PingFang-SC-Medium;
        color: #ff593a;
        opacity: 1;
      }
    }

    .detail_text {
      margin-top: vw(35);
      margin-left: vw(66);
      font-size: vw(24);
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: vw(41);
      color: $theme-color;
      opacity: 1;
    }

    .img {
      margin-left: vw(12);
      margin-top: vw(50);
      width: vw(17);
      height: vw(17);
      border: vw(2) solid $theme-color;
      opacity: 1;
    }

    .to_pay {
      /* margin-right: vw(35);*/
      margin-top: vw(14);
      margin-left: vw(332);
      width: vw(200);
      height: vw(80);
      background: linear-gradient(135deg, #ff8433 0%, #ff3530 100%);
      opacity: 1;
      border-radius: vw(8);

      .to_pay_text {
        text-align: center;
        font-size: vw(30);
        font-family: PingFang-SC-Bold;
        line-height: vw(40);
        color: #ffffff;
        opacity: 1;
      }
    }
  }
}
</style>
